module.exports = __webpack_public_path__ + "img/2.16ae8217.svg";